angular.module('iconoglobe')
.service('deviceBrowser', [function(){
  var windows = /IEMobile/i.test(navigator.userAgent);
  var android =  /Android/i.test(navigator.userAgent);
  var blackberry = /BlackBerry/i.test(navigator.userAgent);
  var ios =  /iPhone|iPad|iPod/i.test(navigator.userAgent);
  
  this.isMS = function(){
    // Get IE or Edge browser version
    var version = this.detectMS();
    if(version){
      return true;
    }
    else {
      return version;
    }
  }
  
  this.isIE = function(){
    var version = this.detectMS();
    if(version && version < 12){
      return true;
    }
    else {
      return false;
    }
  }
  
  this.isEdge = function(){
    var version = this.detectMS();
    if(version >= 12){
      return true;
    }
    else {
      return false;
    }
  }
  /**
   * detect IE
   * returns version of IE or false, if browser is not Internet Explorer
   */
  this.detectMS = function() {
    var ua = window.navigator.userAgent;
    var msie = ua.indexOf('MSIE ');
    if (msie > 0) {
      // IE 10 or older => return version number
      return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
    }
    var trident = ua.indexOf('Trident/');
    if (trident > 0) {
      // IE 11 => return version number
      var rv = ua.indexOf('rv:');
      return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
    }
    var edge = ua.indexOf('Edge/');
    if (edge > 0) {
      // Edge (IE 12+) => return version number
      return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
    }
    // other browser
    return false;
  }
  this.isTabPhone = function(){
    return (android || blackberry || ios || windows);
  }
}]);